import { render, staticRenderFns } from "./Admin_Geo_Tags.vue?vue&type=template&id=7163302f&"
import script from "./Admin_Geo_Tags.vue?vue&type=script&lang=js&"
export * from "./Admin_Geo_Tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports